// Battery calibration status (server/automations/batteryNightCharge.js · calibrationStatus):
// a full charge every few weeks re-references the BMS; an unfinished night is finished the
// next night while the pack is held by day.

import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '/api') + '/battery-night-charge'

export async function fetchBatteryCalibration() {
  const r = await apiFetch(`${BASE}/calibration`)
  if (!r.ok) throw new Error(`battery-night-charge ${r.status}`)
  return r.json()
}
